import React from 'react';
import CSSModules from 'react-css-modules';
import {injectIntl, intlShape} from 'react-intl';
import styles from './payNowSuccess.scss';

@injectIntl
@CSSModules(styles, {allowMultiple: true})
class PaymentAmount extends React.Component {

  static propTypes = {
    intl: intlShape,
  };

  render() {
    const {intl:{formatMessage}} = this.props;

    return (
      <div styleName="payNowSuccess">
        <div styleName="innerWrap">
          <div styleName="paidCircle"><span styleName="text">{formatMessage({id:'payNow.confirm.paid'})}</span></div>
          <div styleName="thanks">{formatMessage({id:'payNow.confirm.successMessage'})}</div>
        </div>
      </div>
    );
  }
}


export default PaymentAmount;



// WEBPACK FOOTER //
// ./src/pay-now/PayNowSuccess.js